import React, { useEffect, useState } from 'react'
import { CBadge } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilCalculator, cilPencil, cilPuzzle, cilSpeedometer, cilUser, cilChart, cilHospital, cilTablet, cilLibraryBuilding, cilHttps, cilScreenDesktop, cilLibrary, cilDisabled, cibStackbit, cilCalendar, cilPhone, cilUserPlus, cilCalendarCheck } from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle, CLink, CNavLink } from '@coreui/react'
import {Archive, Calendar, CalendarArrowDownIcon, ChartNoAxesCombined, FileBox, Grid, LayoutDashboard, LayoutGrid, LineChart, MessageCircle, NotepadText, UsersRound } from 'lucide-react'
import { CiPhone } from 'react-icons/ci'

const getNav = () => {
  const userRole = JSON.parse(localStorage.getItem('user'))
  let _nav = []

  return [
      {
        component: CNavItem,
        name: 'Analytics',
        to: '/home/analytics',
        icon: <LineChart className="nav-icon" style={{ color: '#b1b7c1', fill: 'transparent' }} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
      },
    

       {
        component: CNavItem,
        name: 'Dashboard',
        to: '/home/dashboard',
        icon: <LayoutDashboard className="nav-icon" style={{ color: '#b1b7c1', fill: 'transparent' }} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
      },
   
      {
        component: CNavItem,
        name: 'Scheduler',
        to: '/home/appointmentScheduler',
        icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
      },

      {
        component: CNavGroup,
        name: 'Patients',
        to: '/dashboard',
        icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
        items: [
          {
            component: CNavItem,
        name: 'Add Patients',
        to: '/home/patient',
        // icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
          },
           {
        component: CNavItem,
        name: 'Archive Patients',
        to: '/home/archive-patients',
        // icon: <Archive className="nav-icon" style={{ color: '#b1b7c1', fill: 'transparent' }} />,
        role: ['admin', 'office', 'back office'],
      },
        ]
         
      },
      {
        component: CNavItem,
        name: 'Scheduled Appointments',
        to: '/home/appointment',
        icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
      },
      {
        component: CNavItem,
        name: 'All Charts',
        to: '/home/all-appointment',
        icon: <CalendarArrowDownIcon className="nav-icon" style={{ color: '#b1b7c1', fill: 'transparent' }} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
      },
      {
        component: CNavItem,
        name: 'Orders Summary',
        to: '/home/patient-orders',
        icon: <FileBox className="nav-icon" style={{ color: '#b1b7c1', fill: 'transparent' }} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
      },
      // {
      //   component: CNavItem,
      //   name: 'Scheduler',
      //   to: '/home/Scheduler',
      //   icon: < CIcon icon={cilCalendar} customClassName="nav-icon" />,
      //   role: ['admin']
      // },
      //  {
      //    component: CNavGroup,
      //    name: 'Scheduler',
      //    to: '/dashboard',
      //    icon: < CIcon icon={cilCalendar} customClassName="nav-icon" />,
      //    items: [

      //      {
      //        component: CNavItem,
      //        name: 'Scheduler',
      //        to: '/home/Scheduler',
      //        role: ['admin']
      //      },
      //      {
      //        component: CNavItem,
      //        name: 'Appointment Scheduler',
      //        to: '/home/appointmentScheduler',
      //        role: ['admin']
      //      },

      //    ],
      //  },
      {
        component: CNavItem,
        name: 'Call Center',
        to: '/dashboard/callcenter',
        icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
        role: ['admin', 'callcenter', 'office', 'back office'],
      },

      {
        component: CNavGroup,
        name: 'Master Databases',
        to: '/home',
        icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
        items: [
          // {
          //   component: CNavItem,
          //   name: 'Dashboard',
          //   to: '/home/dashboard',
          //   role:['admin']
          // },
          // {
          //           component: CNavLink,
          //           name: 'Task Management',
          //           href: "https://localhost:3000",
          //           target:"_blank"
          //         },

          {
            component: CNavItem,
            name: 'Facility',
            to: '/home/facility',
            role: ['admin'],
          },

          {
            component: CNavItem,
            name: 'Diagnosis',
            to: '/home/diagnosis',
            role: ['admin'],
          },

          {
            component: CNavItem,
            name: 'Risk Factors',
            to: '/home/risks',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Differential Diagnosis',
            to: '/home/differentialDiagnosis',
            role: ['admin'],
          },

          // {
          //   component: CNavItem,
          //   name: 'Plan Suggestions',
          //   to: '/home/suggestionDiagnosis',
          //   role: ['admin']
          // },

          {
            component: CNavItem,
            name: 'Labs',
            to: '/home/labsmaster',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Medication',
            to: '/home/medication',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Imaging',
            to: '/home/imaging',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Provider Question',
            to: '/home/questions',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Assessment Suggestions',
            to: '/home/assessmentSuggestions',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Template Plan Statement',
            to: '/home/template-plan-statement',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Physical Examination',
            to: '/home/physicalView',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Insurance',
            to: '/home/insurance',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Education',
            to: '/home/educations',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Diagnosis Data',
            to: '/home/diagnosis-data',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Miscellaneous',
            to: '/home/miscellaneous',
            role: ['admin'],
          },
        ],
        role: ['admin'],
      },
      {
        component: CNavGroup,
        name: 'Facility',
        to: '/dashboard',
        icon: <CIcon icon={cilHospital} customClassName="nav-icon" />,
        items: [
          {
            component: CNavItem,
            name: 'Facility Type',
            to: '/home/facilityType',
            role: ['admin', 'office', 'back office'],
          },
          {
            component: CNavItem,
            name: 'Facility Map',
            to: '/home/facilityMap',
            role: ['admin', 'office', 'back office'],
          },
        ],
      },
      {
        component: CNavItem,
        name: 'Credentialing',
        to: '/home/credentialing',
        icon: <CIcon icon={cilLibraryBuilding} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
      },
      {
        component: CNavGroup,
        name: 'Provider',
        to: '/dashboard',
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
        items: [
          {
            component: CNavItem,
            name: 'Provider Master',
            to: '/home/providermaster',
            role: ['admin', 'office', 'back office'],
          },
          // {
          //   component: CNavItem,
          //   name: 'Provider Appointment',
          //   to: '/home/provider/appointment',
          //   role: ['admin', 'provider'],
          // },

          // {
          //   component: CNavItem,
          //   name: 'Incident Questions',
          //   to: '/home/incidentQuestions',
          //   role: ['admin']
          // },
          // {
          //   component: CNavItem,
          //   name: 'Physical Examination',
          //   to: '/home/physicalExaminations',
          //   role: ['admin']
          // },
          // {
          //   component: CNavItem,
          //   name: 'HPI Questions',
          //   to: '/home/providerQuestions',
          //   role: ['admin']
          // },
          // {
          //   component: CNavItem,
          //   name: 'FollowUp Question',
          //   to: '/home/providerfollowups',
          //   role: ['admin']
          // },
          // {
          //   component: CNavItem,
          //   name: 'Question',
          //   to: '/home/questions',
          //   role: ['admin']
          // },
          ],
        },
      {
        component: CNavItem,
        name: 'HRM',
        to: '/home/hrm',
        icon: <UsersRound className="nav-icon" style={{ color: '#b1b7c1', fill: 'transparent' }} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
      },
      {
        component: CNavGroup,
        name: 'Login',
        to: '/dashboard',
        icon: <CIcon icon={cilHttps} customClassName="nav-icon" />,
        role: ['admin'],
        items: [
          {
            component: CNavItem,
            name: 'Login Application Type',
            to: '/home/applicationType',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Login Master',
            to: '/home/hospitalLoginMaster',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Login',
            to: '/home/hospitalLogin',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Create User',
            to: '/register',
            role: ['admin'],
          },
          {
            component: CNavItem,
            name: 'Users',
            to: '/home/users',
            role: ['admin'],
          },
        ],
      },
      // {
      //   component: CNavGroup,
      //   name: 'Backend',
      //   to: '/dashboard',
      //   icon: <CIcon icon={cilScreenDesktop} customClassName="nav-icon" />,
      //   items: [

      // {
      //   component: CNavItem,
      //   name: 'Scheduler',
      //   to: '/home/Scheduler',
      //   role: ['admin']
      // },
      // {
      //   component: CNavItem,
      //   name: 'Call Center',
      //   to: '/dashboard/callcenter',
      //   role: ['admin', 'callcenter']
      // },

      // ],
      // },
      {
        component: CNavGroup,
        name: 'Forms',
        to: '/dashboard',
        icon: <CIcon icon={cilLibrary} customClassName="nav-icon" />,
        items: [
          {
            component: CNavItem,
            name: 'Diagnosis Form Builder',
            to: '/home/formbuilder',
            role: ['admin', 'office', 'back office'],
          },
          {
            component: CNavItem,
            name: 'Call Center Form',
            to: '/home/callCenterForm',
            role: ['admin', 'office', 'back office'],
          },
          {
            component: CNavItem,
            name: 'Facility Form Builder',
            to: '/home/facilityBuilder',
            role: ['admin', 'office', 'back office'],
          },
        ],
      },
      {
        component: CNavGroup,
        name: 'Task Management',
        to: '/dashboard',
        icon: <CIcon icon={cibStackbit} customClassName="nav-icon" />,
        items: [
          {
            component: CNavItem,
            name: 'Dashboard',
            to: '/home/all-tasks',
            role: ['admin', 'callcenter', 'backend', 'office', 'back office'],
          },

          // {
          //   component: CNavItem,
          //   name: 'Temp Kanban Board',
          //   to: '/home/temp-kanban',
          //   role: ['admin', 'callcenter', 'backend', 'office'],
          // },
          // {
          //   component: CNavItem,
          //   name: 'Task Manager',
          //   to: '/home/kanban',
          //   role: ['admin','callcenter','backend','office']
          // },
        ],
      },
      {
        component: CNavLink,
        name: 'Cerebrum Chat',
        href: 'https://103.27.120.199/ProvioChatApp/login',
        target: '_blank',
        rel: 'noopener noreferrer',
        icon: <MessageCircle className="nav-icon" style={{ color: '#b1b7c1', fill: 'transparent' }} customClassName="nav-icon" />,
        role: ['admin', 'office', 'back office'],
      },


      // {
      //   component: CNavItem,
      //   name: 'Provider View',
      //   to: '/home/provider',
      //   icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
      //   role: ['admin'],
      // },

      // {
      //   component: CNavTitle,
      //   name: 'Features',
      // },
      // {
      //   component: CNavLink,
      //   name: 'Config',
      //   href:'http://localhost/RNB_ADM_DASH/Webpages/frmConfigDashBoard.aspx',
      //   target:"_blank",
      //   icon: <CIcon icon={cilPencil} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavLink,
      //   name: 'Data Correction',
      //   href:'http://localhost/RNB_ADM/Login.aspx',
      //   target:"_blank",
      //   icon: <CIcon icon={cilPencil} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavGroup,
      //   name: 'Data Warehouse',
      //   to: '/datawarehouse/RPMS/RawData',
      //   icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
      //   items:[
      //     {
      //       component: CNavGroup,
      //       name: 'RPMS',
      //       to:'/',
      //       items:[{
      //         component: CNavGroup,
      //         name: 'Raw Data',
      //         items:[{
      //           component: CNavItem,
      //           name: 'Road Data',
      //           to: '/datawarehouse/RPMS/[1,1,"Roads"]',

      //         },
      //         {
      //           component: CNavItem,
      //           name: 'Bridges Data',
      //           to: '/datawarehouse/RPMS/[1,1,"Bridges"]',
      //         }
      //         ]},
      //       {
      //         component: CNavGroup,
      //         name: 'Processed Data',
      //         items:[{
      //           component: CNavItem,
      //           name: 'Master Table',
      //           to: '/datawarehouse/RPMS/[1,2,"Master"]',

      //         },
      //         {
      //           component: CNavItem,
      //           name: 'Contractor',
      //           to: '/datawarehouse/RPMS/[1,2,"Contractor"]',
      //         },
      //         {
      //           component: CNavItem,
      //           name: 'Pending Work',
      //           to: '/datawarehouse/RPMS/[1,2,"Pending"]',
      //         },
      //         {
      //           component: CNavItem,
      //           name: 'Delay Data',
      //           to: '/datawarehouse/RPMS/[1,2,"Delay"]',
      //         },

      //         ]
      //       }]
      //     },
      //     {
      //       component: CNavGroup,
      //       name: 'State WMS',
      //       to:'/',
      //       items:[{
      //         component: CNavGroup,
      //         name: 'Raw Data',
      //         items:[{
      //           component: CNavItem,
      //           name: 'ALL Data',
      //           to: '/datawarehouse/RPMS/[2,106,"ALL"]',
      //         }
      //         ]
      //       }]
      //       },
      //       {
      //         component: CNavGroup,
      //         name: 'GujRams',
      //         to:'/',
      //         items:[{
      //           component: CNavGroup,
      //           name: 'Raw Data',
      //           items:[{
      //             component: CNavItem,
      //             name: 'Roads Data',
      //             to: '/datawarehouse/RPMS/[10,10,"Roads"]',
      //           },
      //           {
      //             component: CNavItem,
      //             name: 'Accident Data',
      //             to: '/datawarehouse/RPMS/[10,10,"Accident"]',
      //           }
      //           ]
      //         }]
      //         },
      //     // {
      //     //   component: CNavGroup,
      //     //   name: 'GujRAMS',
      //     //   to: '/dashboard'
      //     // },
      //   ]
      // },
      // {
      //   component: CNavItem,
      //   name: 'User Creation',
      //   to: '/register',
      //   icon: <CIcon icon={cilTablet} customClassName="nav-icon" />,
      //   role:['admin']
      // },
    ]
}

export default getNav
